module.exports = __webpack_public_path__ + "img/748.92241e0f.png";